import { Colors, Icon, Text } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { GlassFrame, IconCircle } from '../components/surfaces';

import ObjectivePeriodFilter from '@/components/objectives/ObjectivePeriodFilter';
import { OVERVIEW_HERO_TITLE } from '@/components/objectives/objectiveStyles';

/**
 * The page's hero: the people roundel, title and subtitle on the left, the cycle pill and its
 * select on the right. Both halves sit in one wrapping flex row, so the select drops under the
 * title on narrow widths without a responsive variant -- a base utility beats its own `md:`
 * variant in this Tailwind v4 build (see the note above `.obj-header` in `app.css`).
 */
export default function EmployeesWithoutObjectivesHeader() {
    const { t } = useTranslation();

    return (
        <GlassFrame dataTestId={'employees-without-objectives-header'}>
            <div className={'flex flex-wrap items-center justify-between gap-6'}>
                <div className={'flex items-center gap-3'}>
                    <IconCircle className={'bg-obj-tint obj-header-icon-circle'}>
                        <Icon
                            name={'users-profile-2user'}
                            size={36}
                            color={Colors.STEP_RAIL_TURQUOISE}
                            strokeWidth={1.8}
                            className={'obj-header-icon-svg'}
                        />
                    </IconCircle>

                    <div>
                        <h1 className={`${OVERVIEW_HERO_TITLE} mb-1`}>
                            {t('employeesWithoutObjectives.title')}
                        </h1>

                        <Text color={Colors.NAVY}>{t('employeesWithoutObjectives.subtitle')}</Text>
                    </div>
                </div>

                {/* Full width on a phone, like the toolbars' period row: sized by its content, a
                    long period name would set the width and push the page sideways. */}
                <div className={'flex flex-wrap items-center gap-3 max-sm:w-full'}>
                    {/* 44px, the height of the toolbar's search field below; the period select
                        next to it keeps the library's 40px and is centred on the same row. */}
                    <span
                        className={
                            'text-navy flex h-[44px] items-center gap-2 rounded-[12px] border border-white bg-white/70 px-4 text-[14px] font-medium whitespace-nowrap'
                        }
                    >
                        <span
                            aria-hidden
                            className={'text-obj-accent flex'}
                        >
                            <Icon
                                name={'time-calendar'}
                                size={'sm'}
                                color={'inherit'}
                            />
                        </span>

                        {t('employeesWithoutObjectives.cycleLabel')}
                    </span>

                    <ObjectivePeriodFilter />
                </div>
            </div>
        </GlassFrame>
    );
}
